


























































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Form, Message } from 'element-ui'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import $Api from '@api'
import { PenaltyFinePageRecord, RepaymentState } from '@/api/model/repayment'
import { translate, DateTime } from '@/utils/filters'
import { finalize } from 'rxjs/operators'

@Component({
    components: {
        SearchForm,
        TableForm
    }
})
export default class extends Vue {
    tableData: PenaltyFinePageRecord[] = []
    shouldTableLoading = false
    total = 0

    shouldTimeDateValue = null
    dateTime = DateTime
    defaultTime = ['00:00:00', '23:59:59']

    searchForm: { [key: string]: any } = {
        current: 1,
        size: 10,
        cameraIdStr: null,
        shouldTimeBegin: null,
        shouldTimeEnd: null,
        phone: null,
        cardNo: null,
        userName: null
    }

    created(): void {
        this.getData()
    }

    getData(pageQuery?: object): void {
        if (pageQuery) {
            Object.assign(this.searchForm, pageQuery)
        }
        this.shouldTableLoading = true
        const formData = this.clearEmptyProperty(this.searchForm)
        $Api.repaymentService
            .penaltyFinePage(formData)
            .pipe(
                finalize(() => {
                    this.shouldTableLoading = false
                })
            )
            .subscribe(res => {
                this.tableData = res.records
                this.total = res.total
            })
    }

    onSearchSubmit(): void {
        this.searchForm.current = 1
        this.getData()
    }

    onFormReset(): void {
        // The resetFields method (from SearchForm.vue) does not take effect on datePicker, need to reset manually
        this.shouldTimeDateValue = null
    }

    viewLoanDetail(row: PenaltyFinePageRecord): void {
        const query = {
            index: String(row.indexs),
            lid: String(row.lid),
            rid: String(row.rid)
        }
        this.$router.push({ path: '/repayment/unpaid/detail', query })
    }

    clearEmptyProperty(source: any): any {
        const cloneSource = Object.assign({}, source)
        Object.keys(cloneSource).forEach(key => {
            if (cloneSource[key] === '' || cloneSource[key] === null) {
                delete cloneSource[key]
            }
        })
        return cloneSource
    }

    get country() {
        return (this.$store.state.auth.authInfo || {}).country
    }

    reset(formName: string): void {
        ;(this.$refs[formName] as Form).resetFields()
    }

    @Watch('shouldTimeDateValue')
    onShouldTimeDateValueChange(date: [Date, Date]): void {
        if (!date) {
            this.searchForm.shouldTimeBegin = null
            this.searchForm.shouldTimeEnd = null
        } else {
            const [shouldTimeBegin, shouldTimeEnd] = date
            this.searchForm.shouldTimeBegin = shouldTimeBegin.getTime()
            this.searchForm.shouldTimeEnd = shouldTimeEnd.getTime()
        }
    }
}
